<template>
  <v-app>
    <v-main>
      <demo1/>
      <!-- <demo2/> -->
      <!-- <demo/> -->
      <!-- <HelloWorld/> -->
    </v-main>
  </v-app>
</template>

<script>
// import HelloWorld from './components/HelloWorld.vue'
// import demo from './components/Demo.vue'
// import demo2 from './components/Demo2.vue'
import demo1 from './components/Demo1.vue'

export default {
  name: 'App',

  components: {
    // HelloWorld,
    //demo,
    //demo2
    demo1
  },

  data: () => ({
    //
  }),
}
</script>
